// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__9VZA9","notes":"Notes_notes__zA-IV"};